<template>
  <v-footer padless fixed id="wenewzRed">
    <v-row justify="center" no-gutters>
      <v-col class="py-3 text-center white--text statusDescr" id="lighterRed" cols="12">
        <div v-if="this.$store.state.register.page==1">
          <span v-if="this.$store.state.register.validInterest=='true'">
            <span>{{$t("Well Done! Add more or")}}</span>

            <v-btn v-on:click="nextBtn()" text color="white" class="pa-1">
              <strong>{{$t("continue")}}</strong>
              <v-icon class="pa-1">fas fa-arrow-right</v-icon>
            </v-btn>
          </span>

          <span
            v-if="this.$store.state.register.validInterest=='false'"
            v-html="$t("Select at least one interest")"
          ></span>
        </div>

        <div v-if="this.$store.state.register.page==2">
          <span
            v-if="this.$store.state.register.validGeo=='false'"
            v-html="$t("Select at least one geo")"
          ></span>

          <div v-if="this.$store.state.register.validGeo=='true'">
            <v-btn v-on:click="submit()">
              <v-icon class="pa-1">far fa-newspaper</v-icon>
              <strong>{{$t("Create frontpage profile")}}</strong>
            </v-btn>
          </div>
        </div>
      </v-col>

      <v-btn
        v-for="item in this.$store.state.register.tagIcons"
        :key="item.id"
        :color="item.color"
        text
        rounded
        class="my-2"
        :disabled="item.status!='active'"
        v-on:click="tagSwitch(item.id)"
      >
        <v-icon class="pa-1">{{item.icon}}</v-icon>
        {{ item.label }}
      </v-btn>
    </v-row>
  </v-footer>
</template>




<script>
import { mapGetters, mapActions } from "vuex";
import messages from "../../modules/lang/export";
export default {
  i18n: { messages },
  data: () => ({}),

  methods: {
    nextBtn() {
      this.$store.commit("changePage", {
        newPage: this.$store.state.register.page == 1 ? 2 : 1,
      });
      this.updateActiveStatus();
    },

    async tagSwitch(id) {
      //id1 = interest, id2 = geo
      // console.log("tagSwitch: ", id);
      if (id == 1 && this.$store.state.register.page == 2) {
        //Load interest page if icon with id 1 is clicked from page 2 (geo)
        await this.$store.commit("changePage", {
          newPage: 1,
        });
        this.updateActiveStatus();
      }
    },

    updateActiveStatus() {
      // console.log("Update status");
      // console.log(this.$store.state.register.tagIcons);
      let _geo = this.$store.state.register.page == 2 ? "active" : "";
      this.$store.commit("changeActiveStatus", {
        index: 1,
        status: _geo,
      });
    },
    submit() {
      this.$emit("done", "Submit feed");
    },
  },
};
</script>


<style scoped>
.statusDescr {
  line-height: 2.2;
  font-size: 1.2em;
}

#wenewzRed {
  background-color: rgb(162, 35, 37);
}

#lighterRed {
  background-color: rgb(177, 39, 41);
}
</style> 